import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBgv-ppUH_DmSrp5X6fyIpFrgO2jzc_Ueo",
    authDomain: "portfolio-c88e4.firebaseapp.com",
    databaseURL: "https://portfolio-c88e4-default-rtdb.firebaseio.com",
    projectId: "portfolio-c88e4",
    storageBucket: "portfolio-c88e4.appspot.com",
    messagingSenderId: "99438019247",
    appId: "1:99438019247:web:df737c0eb438906f290a5a",
    measurementId: "G-37Z4SHE34S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const database = getDatabase(app);

export default app;
